import { Table, Input, Button, Modal, DatePicker } from "antd";
import React, { useEffect, useState } from "react";
import { httpGet, httpUrl, httpPost } from "../../api/httpClient";
import moment from "moment";
import locale from "antd/es/date-picker/locale/ko_KR";
import excelPng from "../../img/excel.png";
import { comma } from "../../lib/util/numberUtil";
import SelectBox from "../../components/common/SelectBox";
import { userTypeCode } from "../../lib/util/codeUtil";

const Search = Input.Search;
const { RangePicker } = DatePicker;
const now = new Date();

const UserList = () => {
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
    });
    const [list, setList] = useState([]);
    const [status, setStatus] = useState(0);
    const [searchType, setSearchType] = useState("")
    const [selected, setSelected] = useState("ALL");
    const [searchText, setSearchText] = useState("");
    const [date, setDate] = useState({
        start: moment().add(-1, 'M').format("YYYY-MM-DD"),
        end: moment().format("YYYY-MM-DD")
      });

    useEffect(() => {
        getList();
    },[date.end, pagination.current, pagination.pageSize, searchText, date.start ]);

    const getList = async () => {
        const endDate = moment(date.end).add(1, 'd').format("YYYY-MM-DD");
        const res = await httpGet(httpUrl.getUserList, [endDate, pagination.current, pagination.pageSize, searchText, selected, date.start], {})
        if (!res) {
            console.log(`getListAsync failed. result: ${res.result}`);
            return;
        }
        setList(res.data.user);
        setPagination({
            ...pagination,
            total: res.data.totalCount
        })
    };

    const handleTableChange = (page) => {
        if (page.current !== pagination.current) {
            setPagination({
                ...pagination,
                current: page.current
            });
        } else if (page.pageSize !== pagination.pageSize) {
            setPagination({
                ...pagination,
                current: 1,
                pageSize: page.pageSize
            });
        }
    };

    
    
    const columns = [        
        {
            title: "유저키",
            dataIndex: "userKey",
            className: "column-center",
        },
        {
            title: "가입일",
            dataIndex: "createDate",
            className: "column-center",
            render : (data)=> moment(data).format("YYYY-MM-DD HH:mm:ss")
        },
     
    ];

    const onSearch = (value) => {
        setSearchText(value);
        getList();
    };

    const onSelect = (value) => {
        setSelected(value);
    };

    const reset =() =>{
        setStatus(0)
        setDate({
            start: moment(now).format('YYYY-MM-DD'),
            end: moment(now).format('YYYY-MM-DD')
        })
        setSearchText("")
        setSelected("ALL")
    };

    const onChangeDate = (type) => {
        switch (type) {
            case 0 : {
                setStatus(0);
                setDate({
                    start: moment().format("YYYY-MM-DD"),
                    end: moment().format("YYYY-MM-DD")
                })
            } break;
            case 1 : {
                setStatus(1);
                setDate({
                    start: moment().add(-7, 'd').format("YYYY-MM-DD"),
                    end: moment().format("YYYY-MM-DD")
                })
            } break;
            case 2 : {
                setStatus(2);
                setDate({
                    start: moment().subtract(3, 'M').format("YYYY-MM-DD"),
                    end: moment().format("YYYY-MM-DD")
                })
            } break;
            case 3 : {
                setStatus(3);
                setDate({
                    start: moment('2023-01-01').format("YYYY-MM-DD"),
                    end: moment().format("YYYY-MM-DD")
                })
            } break;
        }
    }
    const onChangeRangePicker = async (e, selectDate, value) => {
        setStatus(4)
        setDate({
            start: moment(selectDate[0]).format('YYYY-MM-DD'),
            end: moment(selectDate[1]).format('YYYY-MM-DD')
        })
    };

    const disabledDate = (current) => {
    return current && current > moment().endOf('day');
    };
    
    return (
        <div className="main">
        <div className="main-title">
            유저 목록
        </div>
            <div className="top-bar">
               <div id="selectBox">
                    <Button className={status === 0 && "active"}  onClick={()=>onChangeDate(0)}>
                        금일
                    </Button>
                    <Button className={status === 1 && "active"}  onClick={()=>onChangeDate(1)}>
                        1주일
                    </Button>
                    <Button className={status === 2 && "active"}  onClick={()=>onChangeDate(2)}>
                        3개월
                    </Button>
                    <Button className={status === 3 && "active"}  onClick={()=>onChangeDate(3)}>
                        전체
                    </Button>
                    <p>
                    <RangePicker
                        style={{padding:5, borderRadius:5, marginRight:10,  border:'1px solid #888',height:32}}
                        locale={locale}
                        format={"YYYY-MM-DD"}
                        allowClear={false}
                        picker="date"
                        value={[
                        moment(date.start, "YYYY-MM-DD"),
                        moment(date.end, "YYYY-MM-DD"),
                        ]}
                        onChange={onChangeRangePicker}
                        disabledDate={disabledDate}
                    />
                    </p>
                    <SelectBox
                        name="searchType"
                        className="memo-select" 
                        style={{width:100}}
                        placeholder={userTypeCode}
                        code={Object.keys(userTypeCode)}
                        codeString={userTypeCode}
                        onChange={(value) => {onSelect(value)}}
                        value={selected}
                    />              
                    <Input.Search
                        placeholder="검색어를 입력하세요"
                        className="search-input"
                        enterButton
                        allowClear
                        onSearch={onSearch}
                        value={searchText}
                        onChange={(e)=>{
                            setSearchText(e.target.value.trim());
                        }}
                    />
                </div>
                <Button onClick={()=>reset()}>
                   초기화
                </Button>
            </div>
           <div className="top-table">
                <div className="top-table-container">
                        <div>
                        총 <span> {comma(pagination.total)}</span>건이 검색되었습니다.
                        </div>
                        <div>
                        {/* <Button className="download-btn"
                            // onClick={() => onDownload()}
                        > 
                        <div>
                            <img src={excelPng} alt="" />다운로드
                        </div>
                        </Button> */}
                        </div>
                 </div>

                <Table
                    rowKey={(record) => record.userKey}
                    dataSource={list}
                    columns={columns}
                    pagination={pagination}
                    onChange={handleTableChange}
                />
             </div>
        </div>
    );

}

export default UserList;
